require(['jquery', 'popupsUtil'], function ($, PopupsUtil) {
    'use strict';

    $(document).ready(function () {
        // Display on first site visit - set cookie to expire in 2 years
        // Hide on checkout & subscribe landing page
        if (window.location.search.search('sc_src') < 0 &&
            document.cookie.indexOf('firstVisit=true') == -1 &&
            $('.checkout-cart-index').length == 0 &&
            $('.checkout-index-index').length == 0 &&
            $('.cms-subscribe').length == 0) {
            var twoYears = 2 * 365 * 24 * 60 * 60 * 1000; // (2)years * (365)days * (24)hours * (60)minutes  * (60)seconds * (1000)milliseconds
            // this cookie will expire in 2 years
            var expires = new Date(new Date().valueOf() + twoYears);

            //Set popup to display after 15 seconds on page
            setTimeout(function () {
                    PopupsUtil.displayPopUp(false, $('#newsletter_popup_subscriber_box').html(), 'popup__returning-visitor');
                    document.cookie = "firstVisit=true;expires=" + expires.toUTCString() + ";path=/";
                }, 15000 /// milliseconds = 15 seconds
            );
        }
    });
});